var map = {
	"./calendarDate.js": 51,
	"./calendarLimitTo.js": 52,
	"./calendarTruncateEventTitle.js": 53,
	"./calendarTrustAsHtml.js": 54
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;


//////////////////
// WEBPACK FOOTER
// ./src/filters \.js$
// module id = 8
// module chunks = 0